import { DiscoverBrandsList } from "../brands/discover/DiscoverBrandsList";
import { useInfiniteDiscoverBrands } from "../brands/discover/useInfiniteDiscoverBrands";
import { Box } from "@mui/material";

export default function MyTrackedStores() {
  const trendingBrandsContext = useInfiniteDiscoverBrands({
    page: 1,
    page_size: 60,
    ordering: "-scaling_score_ranking",
    action: "tracked_stores",
  });
  return (
    <Box sx={{ mt: 2 }}>
      <DiscoverBrandsList
        isPreFilteredMode={true}
        discoverBrandsContext={trendingBrandsContext}
        columns={[]}
      />
    </Box>
  );
}
